import React from 'react';

const NoMoreResultsFader = () => (
  <p className="no-more-results">
    <i className="far fa-fw fa-flag" /> No more results
  </p>
);

export default NoMoreResultsFader;
